<div id="back-button">
  <button type="button" class="close" aria-label="Close" (click)="goBack()">
    <img src="/assets/img/svg/arrow-back.svg"/>
  </button>
</div>
<div class="modal-header-departament">
  <h4 *ngIf="travelPolicy" class="modal-title heading-5" id="modal-basic-title">
    {{ "common.policies.edit-user-policies" | translate }}
  </h4>
  <h4 *ngIf="!travelPolicy" class="modal-title heading-5" id="modal-basic-title">
    {{ "common.policies.create-user-policies" | translate }}
  </h4>
</div>
<div class="modal-header-explain pb-2">
  <h4 class="modal-title heading-5">
    {{ "common.policies.explanation-policies" | translate }}
  </h4>
</div>
<div class="modal-body p-3 pr-5 pl-5 pb-5">
  <form
    [formGroup]="form"
    [ngClass]="{ 'loading-background': loading }"
    (ngSubmit)="form.valid && !loading ? onSubmit() : (isInvalid = true)"
  >
    <div class="row">
      <div class="col-12 mb-3">
        <div class="form-group-name col-md-6 col-xs-12">
          <label class="tittle-form-control-departament" for="name"
            >{{ "common.name" | translate }}*</label
          >
          <input
            [ngClass]="{
              'input-error': !form.controls.name.valid && isInvalid
            }"
            class="form-control-departament form-control"
            [readOnly]="loading || travelPolicy?.name === 'Default'"
            formControlName="name"
            type="text"
            id="name"
          />
          <div *ngIf="form.get('name').touched && !form.controls.name.valid && isInvalid">
            {{"group.group-form.error.caracters" | translate}}
          </div>
        </div>

        <h4 class="heading-6">
          {{ "group.group-form.hotelFilters" | translate }}
        </h4>
        <div class="row form-group">
          <div class="col-md-3 col-xs-12">
            <div class="form-group-departament">
              <label class="tittle-form-control-departament" for="lodgingType"
                >{{ "group.group-form.room-type" | translate }}*</label
              >
              <select
                [attr.disabled]="loading ? '' : null"
                formControlName="lodgingType"
                id="lodgingType"
                class="form-control-departament form-control icon-arrow-rtl"
                [ngClass]="{
                  'input-error': !form.controls.lodgingType.valid && isInvalid
                }"
              >
                <option
                  *ngFor="let lodgingTypeOption of lodgingTypeOptions"
                  [ngValue]="lodgingTypeOption.value"
                >
                  {{ lodgingTypeOption.text | translate }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-md-3 col-xs-12">
            <div class="form-group-departament-stars">
              <label
                class="tittle-form-control-departament"
                for="stars"
                [ngClass]="{
                  'stars-error': !form.controls.stars.valid && isInvalid
                }"
                >{{ "common.stars" | translate }}*</label
              >
              <ngb-rating
                id="stars"
                [max]="5"
                [(rate)]="starRating"
                [readonly]="loading"
                formControlName="stars"
                id="stars"
              ></ngb-rating>
            </div>
          </div>
          <div class="col-md-3 col-xs-12">
            <div class="form-group">
              <label class="tittle-form-control-departament" for="hotelDaysInAdvance">{{
                "company.group.group-form.days-in-advance" | translate
              }} &nbsp;<i
                  class="fa fa-question-circle color-info"
                  matTooltip="{{
                    'group.group-form.advance-days-info' | translate
                  }}"
                ></i></label>
              <input
                [readOnly]="loading"
                formControlName="hotelDaysInAdvance"
                type="number"
                id="hotelDaysInAdvance"
                class="form-control-departament form-control"
              />
            </div>
          </div>
          <div class="col-md-3 col-xs-12">
            <label class="tittle-form-control-departament" for="priceMin"
              >{{
                "departament.departament-form.range-price" | translate
              }}*</label
            >
            <div class="row col-md-12 col-xs-12 pl-0">
              <div class="col-md-6 col-xs-6">
                <div class="form-group">
                  <input
                    [readOnly]="loading"
                    formControlName="priceMin"
                    type="number"
                    id="priceMin"
                    class="form-control-departament form-control w-100"
                    [ngClass]="{
                      'input-error': !form.controls.priceMin.valid && isInvalid
                    }"
                  />
                </div>
              </div>
              <div class="col-md-6 col-xs-6">
                <div class="form-group">
                  <input
                    [readOnly]="loading"
                    formControlName="priceMax"
                    type="number"
                    id="priceMax"
                    class="form-control-departament form-control w-100"
                    [ngClass]="{
                      'input-error': !form.controls.priceMax.valid && isInvalid
                    }"
                  />
                  <div *ngIf="form.get('priceMax').touched && !form.controls.priceMax.valid && isInvalid">
                    {{"group.group-form.error.priceMax" | translate}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="extra-info col-md-8 col-xs-12">
            <img src="assets/img/svg/information.svg" alt="info-icon" />
            {{ "group.group-form.hotel-price-info" | translate }}
          </div>
        </div>
        <div class="col-md-4 pl-0">
          <label class="tittle-form-control-departament">{{
            "departament.departament-form.permissions" | translate
          }}</label>
        </div>
        <div class="row">
          <div class="col-md-4 col-xs-12">
            <div class="form-group">
              <div class="custom-control custom-checkbox m-0">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="onlyAuthorization"
                  formControlName="onlyAuthorization"
                />
                <label class="custom-control-label" for="onlyAuthorization"
                  >{{ "common.onlyAuthorization" | translate }} &nbsp;
                  <i
                    class="fa fa-question-circle color-info"
                    matTooltip="{{
                      'group.group-form.authorization-info' | translate
                    }}"
                  ></i>
                </label>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-xs-12">
            <div class="form-group">
              <div class="custom-control custom-checkbox m-0">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="breakfast"
                  formControlName="breakfast"
                />
                <label class="custom-control-label" for="breakfast">{{
                  "search.card.breakfast" | translate
                }}</label>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-xs-12">
            <div class="form-group">
              <div class="custom-control custom-checkbox m-0">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="requestBooked"
                  formControlName="requestBooked"
                />
                <label class="custom-control-label" for="requestBooked">{{
                  "group.group-form.book-allowed" | translate
                }}&nbsp;<i
                    class="fa fa-question-circle color-info"
                    matTooltip="{{
                      'group.group-form.allow-book-info' | translate
                    }}"
                  ></i></label>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-xs-12">
            <div class="form-group">
              <div class="custom-control custom-checkbox m-0">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="requestCustomBooking"
                  formControlName="requestCustomBooking"
                />
                <label class="custom-control-label" for="requestCustomBooking"
                  >{{ "company.group.group-form.requestBooking-allowed" | translate }} &nbsp;
                  <i
                    class="fa fa-question-circle color-info"
                    matTooltip="{{
                      'group.group-form.request-info' | translate
                    }}"
                  ></i>
                </label>
              </div>
            </div>
          </div>

          <div class="col-md-4 col-xs-12">
            <div class="form-group">
              <div class="custom-control custom-checkbox m-0">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="requestCustomAirbnb"
                  formControlName="requestCustomAirbnb"
                />
                <label class="custom-control-label" for="requestCustomAirbnb"
                  >{{ "company.group.group-form.requestAirbnb-allowed" | translate }} &nbsp;
                  <i
                    class="fa fa-question-circle color-info"
                    matTooltip="{{
                      'group.group-form.request-info' | translate
                    }}"
                  ></i>
                </label>
              </div>
            </div>
          </div>
          
          <div class="col-md-4 col-xs-12">
            <button #locationButton type="button" class="location-button" (click)="openLocationModal()">
              {{ 'group.group-form.price-location' | translate }}
              <span *ngIf="form.value.pricesByLocation?.length > 0" class="location-count">
                {{ form.value.pricesByLocation.length }} 
                {{ form.value.pricesByLocation.length === 1 ? 
                  ('group.group-form.location' | translate) : 
                  ('group.group-form.locations' | translate) }}
              </span>
            </button>
          </div>
        </div>
        <h4 class="heading-6">
          {{ "group.group-form.flightFilters" | translate }}
        </h4>
        <div class="row">
          <!-- política de clase comentada hasta cambio de proveedor -->
        <!-- <div class="row" *ngIf="form.value.sitType">
          <div class="col-md-4 col-xs-12">
            <div class="form-group-departament">
              <label
                class="tittle-form-control-departament"
                for="lodgingType"
                >{{ "group.group-form.sit-type" | translate }}</label
              >
              <select
                [attr.disabled]="loading ? '' : null"
                formControlName="sitType"
                id="sitType"
                class="form-control-departament form-control icon-arrow-rtl"
              >
                <option *ngFor="let s of sits" [ngValue]="s.value">
                  {{ s.viewValue }}
                </option>
              </select>
            </div>
          </div> -->
          <div class="col-md-3 col-xs-12">
            <div class="form-group">
              <label class="tittle-form-control-departament" for="flightDaysInAdvance">{{
                "company.group.group-form.days-in-advance" | translate
              }}&nbsp;<i
                    class="fa fa-question-circle color-info"
                    matTooltip="{{
                      'group.group-form.days-advance-flight' | translate
                    }}"
                  ></i></label>
              <input
                [readOnly]="loading"
                formControlName="flightDaysInAdvance"
                type="number"
                id="flightDaysInAdvance"
                class="form-control-departament form-control"
              />
            </div>
          </div>
          <div class="col-md-4 col-xs-12">
            <label class="tittle-form-control-departament" for="priceMinFlight"
              >{{
                "departament.departament-form.range-price" | translate
              }}*</label
            >
            <div class="row col-md-12 col-xs-12 pl-0">
              <div class="col-md-6 col-xs-6">
                <div class="form-group">
                  <input
                    [readOnly]="loading"
                    formControlName="priceMinFlight"
                    type="number"
                    id="priceMinFlight"
                    class="form-control-departament form-control w-100"
                    [ngClass]="{
                      'input-error': !form.controls.priceMinFlight.valid && isInvalid
                    }"
                  />
                </div>
              </div>
              <div class="col-md-6 col-xs-6">
                <div class="form-group">
                  <input
                    [readOnly]="loading"
                    formControlName="priceMaxFlight"
                    type="number"
                    id="priceMaxFlight"
                    class="form-control-departament form-control w-100"
                    [ngClass]="{
                      'input-error': !form.controls.priceMaxFlight.valid && isInvalid
                    }"
                  />
                  <div *ngIf="form.get('priceMaxFlight').touched && !form.controls.priceMaxFlight.valid && isInvalid">
                    {{"group.group-form.error.priceMax" | translate}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row" style="margin-top: 1.5rem;">
          <div class="col-md-12 col-xs-12">
            <div [formGroup]="form.get('allowAmountOverDuration')">
              <label class="custom-text-info">
                {{ 'group.group-form.amount-duration-prefix' | translate }}
                <input
                  type="number"
                  class="form-inline-input mx-1 input-border"
                  formControlName="amount"
                  [readOnly]="loading"
                  min="1"
                  [placeholder]="'hub.transaction.filters.amount' | translate"
                />
                {{ 'group.group-form.amount-duration-middle' | translate }}
                <input
                  type="number"
                  class="form-inline-input mx-1 input-border"
                  formControlName="duration"
                  [readOnly]="loading"
                  min="1"
                  placeholder="h"
                />
                {{ 'group.group-form.amount-duration-suffix' | translate }}
              </label>
            </div>
          </div>
        </div>
        <div class="col-md-4 pt-3 pl-0">
          <label class="tittle-form-control-departament">{{
            "departament.departament-form.permissions" | translate
          }}</label>
        </div>

        <div class="row">
            <div class="col-md-4 col-xs-12">
              <div class="form-group">
                <div class="custom-control custom-checkbox m-0">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="flight"
                    formControlName="flight"
                  />
                  <label class="custom-control-label" for="flight">{{
                    "group.group-form.flight-allowed" | translate
                  }} &nbsp;<i
                    class="fa fa-question-circle color-info"
                    matTooltip="{{
                      'group.group-form.allow-flight-info' | translate
                    }}"
                  ></i></label>
                </div>
              </div>
            </div>
            <div class="col-md-4 col-xs-12">
              <div class="form-group">
                <div class="custom-control custom-checkbox m-0">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="requestCustomFlight"
                    formControlName="requestCustomFlight"
                  />
                  <label class="custom-control-label" for="requestCustomFlight"
                    >{{ "group.group-form.customFlight-allowed" | translate }} &nbsp;
                    <i
                      class="fa fa-question-circle color-info"
                      matTooltip="{{
                        'group.group-form.request-info' | translate
                      }}"
                    ></i>
                  </label>
                </div>
              </div>
            </div>
            <!-- PENDIENTE FILTRO DE VUELO POR UBICACIÓN / AEROUPERTO -->
            <!-- <div class="col-md-4 col-xs-12" style="margin-bottom: 1.5rem;">
              <button #airportButton type="button" class="location-button" (click)="openAirportModal()">
                {{ 'group.group-form.price-route' | translate }}
                <span *ngIf="form.value.pricesByAirport?.length > 0" class="location-count">
                  {{ form.value.pricesByAirport.length }} 
                  {{ form.value.pricesByAirport.length === 1 ?
                    ('group.group-form.route' | translate) :
                    ('group.group-form.routes' | translate) }}
                </span>
              </button>
            </div> -->

            <div class="col-md-4 col-xs-12">
              <div class="form-group">
                <div class="custom-control custom-checkbox m-0">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="onlyFlightAuthorization"
                    formControlName="onlyFlightAuthorization"
                  />
                  <label
                    class="custom-control-label"
                    for="onlyFlightAuthorization"
                    >{{ "common.onlyFlightAuthorization" | translate }} &nbsp;
                    <i
                      class="fa fa-question-circle color-info"
                      matTooltip="{{
                        'group.group-form.authorization-info' | translate
                      }}"
                    ></i>
                  </label>
                </div>
              </div>
          </div>
        </div>
        <h4 class="heading-6">
          {{ "group.group-form.train-filters" | translate }}
        </h4>
        <!-- FILTROS DE TREN -->
        <div class="row">
          <div class="col-md-3 col-xs-12">
            <div class="form-group">
              <label class="tittle-form-control-departament" for="trainDaysInAdvance">{{
                "company.group.group-form.days-in-advance" | translate
              }} &nbsp;<i
                    class="fa fa-question-circle color-info"
                    matTooltip="{{
                      'group.group-form.days-advance-train' | translate
                    }}"
                  ></i></label>
              <input
                [readOnly]="loading"
                formControlName="trainDaysInAdvance"
                type="number"
                id="trainDaysInAdvance"
                class="form-control-departament form-control"
              />
            </div>
          </div>
          <div class="col-md-4 col-xs-12">
            <label class="tittle-form-control-departament" for="priceMinTrain"
              >{{
                "departament.departament-form.range-price" | translate
              }}*</label
            >
            <div class="row col-md-12 col-xs-12 pl-0">
              <div class="col-md-6 col-xs-6">
                <div class="form-group">
                  <input
                    [readOnly]="loading"
                    formControlName="priceMinTrain"
                    type="number"
                    id="priceMinTrain"
                    class="form-control-departament form-control w-100"
                    [ngClass]="{
                      'input-error': !form.controls.priceMinTrain.valid && isInvalid
                    }"
                  />
                </div>
              </div>
              <div class="col-md-6 col-xs-6">
                <div class="form-group">
                  <input
                    [readOnly]="loading"
                    formControlName="priceMaxTrain"
                    type="number"
                    id="priceMaxTrain"
                    class="form-control-departament form-control w-100"
                    [ngClass]="{
                      'input-error': !form.controls.priceMaxTrain.valid && isInvalid
                    }"
                  />
                  <div *ngIf="form.get('priceMaxTrain').touched && !form.controls.priceMaxTrain.valid && isInvalid">
                    {{"group.group-form.error.priceMax" | translate}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 pl-0">
          <label class="tittle-form-control-departament">{{
            "departament.departament-form.permissions" | translate
          }}</label>
        </div>
        <div class="row">
          <div class="col-md-4 col-xs-12">
            <div class="form-group">
              <div class="custom-control custom-checkbox m-0">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="onlyTrainAuthorization"
                  formControlName="onlyTrainAuthorization"
                />
                <label class="custom-control-label" for="onlyTrainAuthorization"
                  >{{ "common.onlyTrainAuthorization" | translate }} &nbsp;
                  <i
                    class="fa fa-question-circle color-info"
                    matTooltip="{{
                      'group.group-form.authorization-info' | translate
                    }}"
                  ></i>
                </label>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-xs-12">
            <div class="form-group">
              <div class="custom-control custom-checkbox m-0">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="train"
                  formControlName="train"
                />
                <label class="custom-control-label" for="train">{{
                  "group.group-form.train-allowed" | translate
                }}</label>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-xs-12">
            <div class="form-group">
              <div class="custom-control custom-checkbox m-0">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="requestCustomTrain"
                  formControlName="requestCustomTrain"
                />
                <label class="custom-control-label" for="requestCustomTrain"
                  >{{ "group.group-form.customTrain-allowed" | translate }} &nbsp;
                  <i
                    class="fa fa-question-circle color-info"
                    matTooltip="{{
                      'group.group-form.request-info' | translate
                    }}"
                  ></i>
                </label>
              </div>
            </div>
          </div>
        </div>
        <h4 class="heading-6">
          {{ "group.group-form.carFilters" | translate }}
        </h4>
        <div class="row">
          <div class="col-md-4 col-xs-12">
            <div class="form-group">
              <div class="custom-control custom-checkbox m-0">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="requestCar"
                  formControlName="requestCar"
                />
                <label class="custom-control-label" for="requestCar"
                  >{{ "departament.departament-form.cars-permission" | translate }} &nbsp;
                  <i
                    class="fa fa-question-circle color-info"
                    matTooltip="{{
                      'group.group-form.request-info' | translate
                    }}"
                  ></i>
                </label>
              </div>
            </div>
          </div>
        </div>

        <h4 class="heading-6" style="margin-top: 1.25rem;">
          {{ "common.assign-to-users" | translate }}
        </h4>
        <div style="padding-top: 1rem;" class="row g-3 align-items-end">
          <div class="col-12 col-md-6">
            <mat-form-field appearance="outline" class="vyoo-mat-field pill w-100">
              <mat-label>{{ 'company.card.select-scope' | translate }}</mat-label>
              <mat-select [(value)]="assignmentScope">
                <mat-option value="none">{{ 'common.not-assign' | translate }}</mat-option>
                <mat-option value="all">{{ 'company.card.all-users' | translate }}</mat-option>
                <mat-option value="departments">{{ 'company.card.departments' | translate }}</mat-option>
                <mat-option value="users">{{ 'company.card.individual-users' | translate }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-12 col-md-6">
            <ng-container [ngSwitch]="assignmentScope">
              <ng-container *ngSwitchCase="'departments'">
                <mat-form-field appearance="outline" floatLabel="always" class="vyoo-mat-field w-100">
                  <mat-label>{{ 'company.card.select-departments' | translate }}</mat-label>
                  <mat-select [(value)]="selectedDepartments" [multiple]="true">
                    <mat-option *ngFor="let department of departments" [value]="department.uuid">
                      {{ department.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </ng-container>

              <ng-container *ngSwitchCase="'users'">
                <mat-form-field appearance="outline" floatLabel="always" class="vyoo-mat-field w-100">
                  <mat-label>{{ 'company.card.select-users' | translate }}</mat-label>
                  <mat-select
                    [(value)]="selectedUsers"
                    [multiple]="true"
                    (openedChange)="!$event && resetUsersFilter()"
                    panelClass="users-select-panel"
                  >
                    <mat-option class="search-option" disabled>
                      <input
                        class="custom-mat-input"
                        style="border: none; width: 100%;"
                        matInput
                        [value]="searchUserText"
                        (input)="filterCompanyUsers($any($event.target).value)"
                        (click)="$event.stopPropagation()"
                        (keydown)="$event.stopPropagation()"
                        placeholder="{{ 'common.search-user' | translate }}"
                      />
                    </mat-option>

                    <mat-option
                      *ngFor="let user of companyUsers; trackBy: utilsService.getUuidTracking"
                      [value]="user.uuid"
                      [style.display]="userMatchesSearch(user) ? '' : 'none'"
                    >
                      {{ user.name }} {{ user.lastname }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </ng-container>
              <ng-container *ngSwitchDefault></ng-container>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
    <div class="row-button">
      <div class="text-rigth mt-3">
        <button
          type="button"
          class="custom-btn custom-btn--close mb-0"
          aria-label="Close"
          (click)="goBack()"
        >
          {{ "common.return" | translate }}
        </button>
      </div>
      <div class="text-right mt-3">
        <button
          class="custom-btn mb-0"
          ngbAutofocus
          mat-button
          [ngStyle]="{
            cursor: !form.valid || loading ? 'not-allowed' : 'pointer'
          }"
          matTooltip="{{
            (!form.valid || loading ? 'user.form.invalid-form' : '') | translate
          }}"
        >
          {{ "common.send" | translate }}
        </button>
      </div>
    </div>
  </form>
  <div class="row" *ngIf="loading">
    <app-loading [userType]="'employee'"></app-loading>
  </div>
</div>

<div *ngIf="showLocationModal" class="floating-modal-backdrop" (click)="closeLocationModal()">
  <div class="floating-modal" [ngClass]="{'visible': isModalVisible}" [ngStyle]="modalPosition" (click)="$event.stopPropagation()">
    <p class="custom-color">{{ 'group.group-form.pricemax-location' | translate }} &nbsp;<i
                    class="fa fa-question-circle color-info"
                    matTooltip="{{
                      'group.group-form.location-info' | translate
                    }}"
                  ></i></p>
    
  <div *ngIf="form.value.pricesByLocation.length > 0" class="location-list-container">
    <div class="location-list-scroll">
      <div *ngFor="let loc of form.value.pricesByLocation" class="location-item">
        <div class="location-info">
          <span class="location-name">{{ loc.placeName }}</span>
          <span class="location-price">{{ loc.priceMax | price }} €</span>
        </div>
        <button type="button" class="btn btn-sm btn-link text-danger" (click)="removeLocationPrice(loc)">
          <i class="fa fa-trash"></i>
        </button>
      </div>
    </div>
  </div>

    <app-google-autocomplete
      #googleHotelAutocomplete
      [readOnly]="false"
      [fromGroup]="true"
      (setAddress)="handleSetAddress($event)"
      addressType="geocode"
      (invalidAddress)="handleInvalidAddress()"
    ></app-google-autocomplete>

    <div *ngIf="locationError" class="text-danger mt-2">
      {{ locationError }}
    </div>

    <input
      type="number"
      class="form-control mt-3 custom-border"
      [(ngModel)]="newPlacePrice"
      placeholder="{{ 'group.group-form.max-price' | translate }}"
      min="1"
    />

    <div class="d-flex justify-content-end mt-3 buttons-container">
      <button class="btn btn-secondary mr-2" (click)="closeLocationModal()">
        {{ "common.cancel" | translate }}
      </button>
      <button 
        class="btn btn-primary" 
        style="color: white !important;"
        (click)="addLocationPrice()"
        [disabled]="!newPlace || !newPlacePrice"
      >
        {{ "common.add" | translate }}
      </button>
    </div>
  </div>
</div>

<!-- PENDIENTE FILTRO DE VUELO POR UBICACIÓN / AEROUPERTO -->
<!-- <div *ngIf="showAirportModal" class="floating-modal-backdrop" (click)="closeAirportModal()">
  <div class="floating-modal" [ngClass]="{'visible': isAirportModalVisible}" [ngStyle]="modalPosition" (click)="$event.stopPropagation()">
    <p class="custom-color" style="font-size: large;">
      {{ 'group.group-form.maxPrice-route' | translate }} &nbsp;
      <i class="fa fa-question-circle color-info"
         matTooltip="{{ 'group.group-form.airport-info' | translate }}"></i>
    </p>

    <div *ngIf="form.value.pricesByAirport.length > 0" class="location-list-container">
      <div class="location-list-scroll">
        <div *ngFor="let loc of form.value.pricesByAirport" class="location-item">
          <div class="location-info">
            <span class="location-name">{{ loc.placeName }}</span>
            <span class="location-price">{{ loc.priceMax }} €</span>
          </div>
          <button type="button" class="btn btn-sm btn-link text-danger" (click)="removeAirportPrice(loc)">
            <i class="fa fa-trash"></i>
          </button>
        </div>
      </div>
    </div>

    <app-google-autocomplete
      #googleAirportAutocomplete
      [readOnly]="false"
      [fromGroup]="true"
      (setAddress)="handleSetAirport($event)"
      addressType="airport"
      (invalidAddress)="handleInvalidAddress()"
    ></app-google-autocomplete>

    <div *ngIf="airportError" class="text-danger mt-2">
      {{ airportError }}
    </div>

    <input
      type="number"
      class="form-control mt-3 custom-border"
      [(ngModel)]="newAirportPrice"
      placeholder="{{ 'group.group-form.max-price' | translate }}"
      min="1"
    />

    <div class="d-flex justify-content-end mt-3">
      <button class="btn btn-secondary mr-2" (click)="closeAirportModal()">
        {{ "common.cancel" | translate }}
      </button>
      <button 
        class="btn btn-primary" 
        style="color: white !important;"
        (click)="addAirportPrice()"
        [disabled]="!newAirport || !newAirportPrice"
      >
        {{ "common.add" | translate }}
      </button>
    </div>
  </div>
</div> -->
